var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"float-left mr-1"},[_c('span',{staticClass:"text-warning"},[_c('i',{staticClass:"fa fa-usd fa-lg icon-button",attrs:{"title":"Saldo Projeto/Ação"},on:{"click":function($event){$event.stopPropagation();return _vm.obterSaldoProjetoAcao()}}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }